// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Public pages
import { SignInForm } from './Components/login';
import UserNotProvisioned from './Components/UserNotProvisioned.tsx';

// Protected pages
import CompletionsTab from './Components/Completions.tsx';
import FracCalendar from './Components/FracCalendar.tsx';
import MachinaPrototype from './Components/machina-prototype.jsx';
import Plan from './Components/Plan.tsx';

import Settings from './Components/Settings.tsx';
import PadData from './Components/PadData.tsx';
import TreatmentDataGraph from './Components/TreatmentDataGraph.tsx';
import UsersManagement from './Components/UsersManagement.tsx';
import ClientsManagement from './Components/ClientsManagement.tsx';
import Profile from './Components/Profile.tsx';
import AuthRequired from './Components/AuthRequired.tsx';

// Providers
import { AuthProvider } from './context/AuthProvider.tsx';
import { ThemeProvider } from './context/ThemeProvider.tsx';

// UI / CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

// Data fetching
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routes>
              {/* ---------- Public Routes ---------- */}
              <Route path="/sign-in" element={<SignInForm />} />
              <Route path="/user-not-provisioned" element={<UserNotProvisioned />} />

              {/* ---------- Protected Routes ---------- */}
              <Route element={<AuthRequired />}>
                {/* Default app landing: redirect root to pad-data (when authenticated) */}
                <Route path="/" element={<Navigate to="/landing" replace />} />
                <Route path="/completions" element={<CompletionsTab />} />
                <Route path="/calendar" element={<FracCalendar />} />
                <Route path="/landing" element={<MachinaPrototype />} />
                <Route path="/plan" element={<Plan />} />

                {/* App pages */}
                <Route path="/pad-data" element={<PadData />} />

                {/* If you want a non-param page to choose a pad: keep /treatment-data.
                    The working route used only the :padId version, so we include both. */}
                <Route path="/treatment-data" element={<TreatmentDataGraph />} />
                <Route path="/treatment-graph/:padId" element={<TreatmentDataGraph />} />

                <Route path="/profile" element={<Profile />} />

                {/* Nested Settings as before (so Settings can render child routes) */}
                <Route path="/settings" element={<Settings />}>
                  <Route index element={<Navigate replace to="users" />} />
                  <Route path="users" element={<UsersManagement />} />
                  <Route path="clients" element={<ClientsManagement />} />
                </Route>
              </Route>

              {/* ---------- Catch-all ---------- */}
              {/* If not authenticated, AuthRequired should send to /sign-in.
                 For any unknown path, send to sign-in as in the working file. */}
              <Route path="*" element={<Navigate to="/sign-in" replace />} />
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();